import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from '@/hooks/useAuth'
import { useGet } from '@/hooks/useFetch'

export interface BroadcastDeviceWithDetails {
  broadcast_device_id: number
  clinic_id: number
  examination_room_id?: number
  name?: string
  broadcast_type: string
  is_active: boolean
  created_at: string
  updated_at: string
  app_version?: string
  /** 最後連線時間（從 DB 取得） */
  last_connected_at?: string | null
  clinic?: {
    clinic_id: number
    clinic_name: string
    tags?: string[]
  }
}

interface UseBroadcastDevicesParams {
  page: number
  pageSize: number
  search?: string
  versionMismatch?: boolean
  latestVersion?: string
  providerId?: number
}

interface BroadcastDevicesResponse {
  items: BroadcastDeviceWithDetails[]
  pagination: {
    page: number
    pageSize: number
    total: number
    totalPages: number
  }
}

export function useBroadcastDevices({
  page,
  pageSize,
  search,
  versionMismatch,
  latestVersion,
  providerId,
}: UseBroadcastDevicesParams) {
  const { token } = useAuth()

  const params: Record<string, unknown> = {
    page,
    pageSize,
  }

  if (search) params.search = search
  if (versionMismatch && latestVersion) {
    params.versionMismatch = 'true'
    params.latestVersion = latestVersion
  }
  if (providerId) params.providerId = providerId

  const { data, error, mutate } = useGet<ApiResponse<BroadcastDevicesResponse>>(
    token ? '/api/broadcast-devices' : null,
    params,
    token ?? '',
    undefined,
    { keepPreviousData: true },
  )

  return {
    devices: data?.data?.items || [],
    pagination: data?.data?.pagination || null,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
